<template>
    <div class="status-documentacao d-flex d-inline-flex vertical_align_top">
        <div v-if="definirBotao().tipo === 'VISUALIZAR'">
            <v-tooltip top>
                <a slot="activator" :class="'analisar'+definirBotao().estilo" >
                    <span v-if="definirBotao().estilo === '-desabilitado'">
                        <svg :class="'icone-analisar-documento'+definirBotao().estilo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path d="M149.239 16.552V112H53.791v33.103h112c9.142 0 16.552-7.41 16.552-16.552v-112h-33.104z"/>
                            <path :d="'M355.584 0H165.791a16.528 16.528 0 00-11.702 4.85l-112 112a16.543 16.543 0 00'+
                            '-4.85 11.702v275.862c0 9.142 7.41 16.552 16.552 16.552h158.345c9.142 0 16.552-7.41 16.'+
                            '552-16.552s-7.41-16.552-16.552-16.552H70.342V135.404L172.643 33.103h166.389v214.621c0 9'+
                            '.137 7.41 16.552 16.552 16.552s16.552-7.41 16.552-16.552V16.552C372.135 7.41 364.726 0 355.584 0z'"/>
                            <path :d="'M273.929 183.172H135.446c-9.142 0-16.552 7.41-16.552 16.552s7.41 16.552 16.55'+
                            '2 16.552h138.483c9.148 0 16.552-7.41 16.552-16.552-.001-9.142-7.41-16.552-16.552-16.552'+
                            'zM273.929 249.379H135.446c-9.142 0-16.552 7.41-16.552 16.552s7.41 16.552 16.552 16.552h'+
                            '138.483c9.148 0 16.552-7.41 16.552-16.552s-7.41-16.552-16.552-16.552zM347.86 291.862c-'+
                            '51.719 0-93.793 42.074-93.793 93.793s42.074 93.793 93.793 93.793 93.793-42.074 93.793-'+
                            '93.793-42.075-93.793-93.793-93.793zm0 154.483c-33.462 0-60.69-27.228-60.69-60.69s27.228-'+
                            '60.69 60.69-60.69 60.69 27.228 60.69 60.69c-.001 33.462-27.228 60.69-60.69 60.69z'"/>
                            <path :d="'M469.851 483.691l-55.172-54.615c-6.499-6.433-16.971-6.389-23.404.116-6.439 6'+
                            '.499-6.383 16.977.116 23.404l55.172 54.615A16.494 16.494 0 00458.204 512c4.259 0 8.524'+
                            '-1.639 11.763-4.905 6.439-6.499 6.384-16.976-.116-23.404z'"/>
                        </svg>
                        <span class="ml-1">Visualizar</span>
                    </span>
                    <span v-else @click="$emit('analisar')">
                        <svg class="icone-analisar-documento" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path d="M149.239 16.552V112H53.791v33.103h112c9.142 0 16.552-7.41 16.552-16.552v-112h-33.104z"/>
                            <path :d="'M355.584 0H165.791a16.528 16.528 0 00-11.702 4.85l-112 112a16.543 16.543 0 00'+
                            '-4.85 11.702v275.862c0 9.142 7.41 16.552 16.552 16.552h158.345c9.142 0 16.552-7.41 16.5'+
                            '52-16.552s-7.41-16.552-16.552-16.552H70.342V135.404L172.643 33.103h166.389v214.621c0 9.'+
                            '137 7.41 16.552 16.552 16.552s16.552-7.41 16.552-16.552V16.552C372.135 7.41 364.726 0 355.584 0z'"/>
                            <path :d="'M273.929 183.172H135.446c-9.142 0-16.552 7.41-16.552 16.552s7.41 16.552 16.'+
                            '552 16.552h138.483c9.148 0 16.552-7.41 16.552-16.552-.001-9.142-7.41-16.552-16.552-16.5'+
                            '52zM273.929 249.379H135.446c-9.142 0-16.552 7.41-16.552 16.552s7.41 16.552 16.552 16.55'+
                            '2h138.483c9.148 0 16.552-7.41 16.552-16.552s-7.41-16.552-16.552-16.552zM347.86 291.86'+
                            '2c-51.719 0-93.793 42.074-93.793 93.793s42.074 93.793 93.793 93.793 93.793-42.074 93.7'+
                            '93-93.793-42.075-93.793-93.793-93.793zm0 154.483c-33.462 0-60.69-27.228-60.69-60.69s27.'+
                            '228-60.69 60.69-60.69 60.69 27.228 60.69 60.69c-.001 33.462-27.228 60.69-60.69 60.69z'"/>
                            <path :d="'M469.851 483.691l-55.172-54.615c-6.499-6.433-16.971-6.389-23.404.116-6.439 6'+
                            '.499-6.383 16.977.116 23.404l55.172 54.615A16.494 16.494 0 00458.204 512c4.259 0 8.5'+
                            '24-1.639 11.763-4.905 6.439-6.499 6.384-16.976-.116-23.404z'"/>
                        </svg>
                        <span class="ml-1">Visualizar</span>
                    </span>
                </a>
                {{ definirBotao().mensagem }}
            </v-tooltip>
        </div>
        <div v-else-if="definirBotao().tipo === 'ANALISADO'">
            <v-tooltip top >
                <a slot="activator" class="analisado" @click="$emit('analisar')">
                    <i size="20" color="#4A9246" class="fas fa-check" aria-hidden="true"/>
                    <span class="ml-1">Analisado</span>
                </a>
                {{ definirBotao().mensagem }}
            </v-tooltip>
        </div>
        <div v-else-if="definirBotao().tipo === 'ANALISAR'">
            <v-tooltip top >
                <a slot="activator" :class="'analisar'+definirBotao().estilo" >
                    <span v-if="definirBotao().estilo === '-desabilitado'">
                        <svg :class="'icone-analisar-documento'+definirBotao().estilo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path d="M149.239 16.552V112H53.791v33.103h112c9.142 0 16.552-7.41 16.552-16.552v-112h-33.104z"/>
                            <path :d="'M355.584 0H165.791a16.528 16.528 0 00-11.702 4.85l-112 112a16.543 16.543 0 00'+
                            '-4.85 11.702v275.862c0 9.142 7.41 16.552 16.552 16.552h158.345c9.142 0 16.552-7.41 16.'+
                            '552-16.552s-7.41-16.552-16.552-16.552H70.342V135.404L172.643 33.103h166.389v214.621c0 9'+
                            '.137 7.41 16.552 16.552 16.552s16.552-7.41 16.552-16.552V16.552C372.135 7.41 364.726 0 355.584 0z'"/>
                            <path :d="'M273.929 183.172H135.446c-9.142 0-16.552 7.41-16.552 16.552s7.41 16.552 16.552 '+
                            '16.552h138.483c9.148 0 16.552-7.41 16.552-16.552-.001-9.142-7.41-16.552-16.552-16.552zM'+
                            '273.929 249.379H135.446c-9.142 0-16.552 7.41-16.552 16.552s7.41 16.552 16.552 16.552h'+
                            '138.483c9.148 0 16.552-7.41 16.552-16.552s-7.41-16.552-16.552-16.552zM347.86 291.862'+
                            'c-51.719 0-93.793 42.074-93.793 93.793s42.074 93.793 93.793 93.793 93.793-42.074 93.7'+
                            '93-93.793-42.075-93.793-93.793-93.793zm0 154.483c-33.462 0-60.69-27.228-60.69-60.69s27.'+
                            '228-60.69 60.69-60.69 60.69 27.228 60.69 60.69c-.001 33.462-27.228 60.69-60.69 60.69z'"/>
                            <path :d="'M469.851 483.691l-55.172-54.615c-6.499-6.433-16.971-6.389-23.404.116-6.439 6'+
                            '.499-6.383 16.977.116 23.404l55.172 54.615A16.494 16.494 0 00458.204 512c4.259 0 8.524'+
                            '-1.639 11.763-4.905 6.439-6.499 6.384-16.976-.116-23.404z'"/>
                        </svg>
                        <span class="ml-1">Analisar</span>
                    </span>
                    <span v-else @click="$emit('analisar')">
                        <svg class="icone-analisar-documento" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path d="M149.239 16.552V112H53.791v33.103h112c9.142 0 16.552-7.41 16.552-16.552v-112h-33.104z"/>
                            <path :d="'M355.584 0H165.791a16.528 16.528 0 00-11.702 4.85l-112 112a16.543 16.543 0 00'+
                            '-4.85 11.702v275.862c0 9.142 7.41 16.552 16.552 16.552h158.345c9.142 0 16.552-7.41 16.55'+
                            '2-16.552s-7.41-16.552-16.552-16.552H70.342V135.404L172.643 33.103h166.389v214.621c0 9.13'+
                            '7 7.41 16.552 16.552 16.552s16.552-7.41 16.552-16.552V16.552C372.135 7.41 364.726 0 355.584 0z'"/>
                            <path :d="'M273.929 183.172H135.446c-9.142 0-16.552 7.41-16.552 16.552s7.41 16.552 16.55'+
                            '2 16.552h138.483c9.148 0 16.552-7.41 16.552-16.552-.001-9.142-7.41-16.552-16.552-16.552z'+
                            'M273.929 249.379H135.446c-9.142 0-16.552 7.41-16.552 16.552s7.41 16.552 16.552 16.552h13'+
                            '8.483c9.148 0 16.552-7.41 16.552-16.552s-7.41-16.552-16.552-16.552zM347.86 291.862c-51.7'+
                            '19 0-93.793 42.074-93.793 93.793s42.074 93.793 93.793 93.793 93.793-42.074 93.793-93.793'+
                            '-42.075-93.793-93.793-93.793zm0 154.483c-33.462 0-60.69-27.228-60.69-60.69s27.228-60.6'+
                            '9 60.69-60.69 60.69 27.228 60.69 60.69c-.001 33.462-27.228 60.69-60.69 60.69z'"/>
                            <path :d="'M469.851 483.691l-55.172-54.615c-6.499-6.433-16.971-6.389-23.404.116-6.439 6.'+
                            '499-6.383 16.977.116 23.404l55.172 54.615A16.494 16.494 0 00458.204 512c4.259 0 8.524-1.'+
                            '639 11.763-4.905 6.439-6.499 6.384-16.976-.116-23.404z'"/>
                        </svg>
                        <span class="ml-1">Analisar</span>
                    </span>
                </a>
                {{ definirBotao().mensagem }}
            </v-tooltip>
        </div>
        <div v-else-if="definirBotao().tipo === 'AGUARDANDO_ENVIO'">
            <v-tooltip top v-if="definirBotao().desativado">
                <a slot="activator" class="aguardando">
                    {{ value | azEnum(situacoesDocumentacaoFornecedor) }}
                </a>
                {{ definirBotao().mensagem }}
            </v-tooltip>
            <v-tooltip top v-else>
                <a slot="activator" class="aguardando" @click="$emit('analisar')">
                    {{ value | azEnum(situacoesDocumentacaoFornecedor) }}
                </a>
                {{ definirBotao().mensagem }}
            </v-tooltip>
        </div>
        <div v-else>--</div>
        <botao-baixar-todos v-if="deveMostrarBotaoBaixarTodos"
                            texto="Baixar" class="ml-2"
                            :deshabilitar="!isDocApresentado"
                            @baixarTodosDocumentos="baixarTodosDocumentos"/>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import {situacoesDocumentacaoFornecedor} from '@/core/constants'
import BotaoBaixarTodos from '@/views/components/BotaoBaixarTodos.vue'

export default {
    name: 'Documentacao',
    components:{BotaoBaixarTodos},
    props: {
        value: {
            type: String,
            required: true,
            default: null
        },
        statusFornecedor: {
            type: String,
            required: true,
            default: null
        },
        situacaoItemOuLote: {
            type: String,
            required: true,
            default: null
        },
        isDocApresentado: {
            type: Boolean,
            required: true,
            default: null
        },
        permitirVisualizarDocumentoDesempate: {
            type: Boolean,
            required: true,
            default: null
        }
    },
    data() {
        return {
            situacoesDocumentacaoFornecedor
        }
    },
    computed: {
        ...mapState(['resumoCompraDireta', 'comprador']),
        deveMostrarBotaoBaixarTodos(){
            return this.value === 'ANALISADA' && ['EM_ANALISE', 'ADJUDICADO'].includes(this.statusFornecedor)
        }
    },
    methods: {
        existeEmpate() {
            return this.comprador.resultadoItensELotes.some(itemOuLote => itemOuLote.empate === true)
        },
        //TODO refatorar
        definirBotao() {
            if(this.resumoCompraDireta.situacao === 'ENCERRADA') {
                return {
                    tipo: 'VISUALIZAR',
                    estilo: '',
                    mensagem: 'Clique para visualizar a documentação do fornecedor.'
                }
            } else {
                if(this.situacaoItemOuLote !== 'EM_ANDAMENTO') {
                    if(this.ehSituacaoAdjudicadoOuFracassado()){
                        return {
                            tipo: 'VISUALIZAR',
                            estilo: '',
                            mensagem: 'Clique para visualizar a documentação do fornecedor.'
                        }
                    } else {
                        return {
                            tipo: 'VISUALIZAR',
                            estilo: '-desabilitado',
                            mensagem: 'É necessário terminar a análise do resultado para visualizar a documentação deste fornecedor.'
                        }
                    }
                } else {
                    if(this.value === 'ANALISADA') {

                        if (this.statusFornecedor === 'CLASSIFICADO') {
                            return {
                                tipo: 'ANALISAR',
                                estilo: '-desabilitado',
                                mensagem: 'Este fornecedor não está vencendo.'
                            }
                        }

                        return {
                            tipo: 'ANALISADO',
                            mensagem: 'Clique para analisar a documentação do fornecedor.'
                        }
                    } else if(this.value === 'ENTREGUE'){
                        if(this.statusFornecedor === 'EM_ANALISE') {
                            return {
                                tipo: 'ANALISAR',
                                estilo: '',
                                mensagem: 'Clique para analisar a documentação do fornecedor.'
                            }
                        } else if(this.statusFornecedor === 'EMPATADO') {
                            if (this.permitirVisualizarDocumentoDesempate) {
                                return {
                                    tipo: 'VISUALIZAR',
                                    estilo: '',
                                    mensagem: 'Clique para visualizar a documentação do fornecedor.'
                                }
                            } else{
                                return {
                                    tipo: 'ANALISAR',
                                    estilo: '-desabilitado',
                                    mensagem: 'É necessário realizar o desempate de todos os itens antes de analisar a documentação.'
                                }
                            }
                        } else if(this.statusFornecedor === 'DESCLASSIFICADO') {
                            return {
                                tipo: 'VISUALIZAR',
                                estilo: '',
                                mensagem: 'Clique para visualizar a documentação do fornecedor.'
                            }
                        }
                        else {
                            return {
                                tipo: 'ANALISAR',
                                estilo: '-desabilitado',
                                mensagem: 'Este fornecedor não está vencendo.'
                            }
                        }

                    } else if(this.value === 'AGUARDANDO_ENVIO') {
                        if(this.statusFornecedor === 'EM_ANALISE') {
                            if(this.existeEmpate()) {
                                return {
                                    tipo: 'AGUARDANDO_ENVIO',
                                    desativado: true,
                                    mensagem: 'É necessário realizar o desempate de todos os itens antes de analisar a documentação.'
                                }
                            } else {
                                return {
                                    tipo: 'AGUARDANDO_ENVIO',
                                    desativado: false,
                                    mensagem: 'Clique para analisar a documentação do fornecedor.'
                                }
                            }
                        } else if(this.statusFornecedor === 'EMPATADO') {
                            return {
                                tipo: 'AGUARDANDO_ENVIO',
                                desativado: true,
                                mensagem: 'É necessário realizar o desempate de todos os itens antes de analisar a documentação.'
                            }
                        } else {
                            return {
                                tipo: 'AGUARDANDO_ENVIO',
                                desativado: true,
                                mensagem: 'Este fornecedor não está vencendo.'
                            }
                        }
                    } else {
                        return {
                            tipo: 'SEM_VALOR'
                        }
                    }
                }
            }
        },
        ehSituacaoAdjudicadoOuFracassado() {
            const itemLoteAdjudicadoOuFracassado = this.situacaoItemOuLote === 'ADJUDICADO' || this.situacaoItemOuLote === 'FRACASSADO'
            const fornecedorAdjudicadoOuDesclassificado = this.statusFornecedor === 'ADJUDICADO' || this.statusFornecedor === 'DESCLASSIFICADO'
            return itemLoteAdjudicadoOuFracassado && fornecedorAdjudicadoOuDesclassificado
        },
        baixarTodosDocumentos(data){
            this.$emit('baixarTodosDocumentos', data)
        }
    }
}
//TODO Rever as cores aqui também
</script>

<style lang="stylus" scoped>
    .icone-analisar-documento
        height 15px
        width 15px
        fill var(--v-primary-lighten1) !important
        vertical-align middle

    .icone-analisar-documento-desabilitado
        height 15px
        width 15px
        fill #9e9e9e
        vertical-align middle

    .analisar span
        color var(--v-primary-lighten1) !important

    .analisar-desabilitado
        color #9e9e9e
        cursor text

    .aguardando
        color #9e9e9e

    .status-documentacao a
        font-size 13px
</style>
